<template>
  <div class="wrapper f1 df fdrr">
    <div class="page1 f1">
      <CompanyInfo v-if="mode == 'view'"/>
      <CompanyInfoEdit  v-on:viewProfile="cancelChanges()"
                        v-if="mode == 'edit'"/>
    </div>
    <SideBarProfile v-bind:page="'company'"
                    v-bind:editingCompany="mode"
                    v-on:editCompany="editCompany"/>
  </div>
</template>

<script>
import SideBarProfile from '@/components/elements/SideBarProfile'
import CompanyInfo from '@/components/company/CompanyInfo'
import CompanyInfoEdit from '@/components/company/CompanyInfoEdit'

export default {
  name: 'DashboardCompany',
  data () {
    return {
      mode: 'edit' // or edit
    }
  },
  props: [],
  components: {
    SideBarProfile,
    CompanyInfo,
    CompanyInfoEdit
  },
  methods: {
    editCompany () {
      this.mode = 'edit'
    },
    cancelChanges () {
      this.mode = 'view'
    }
  },
  computed: {

  },
  created () {
    // console.log('** Login Component Loaded')
  }
}
</script>

<style scoped lang="scss">
  //
  // Wrapper
  //
  .wrapper {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    padding-left: 50px;
    padding-right: 50px;

    // Responsive Style
    // @media max-width: 768px
    @media(max-width: 768px) {
      flex-direction: column-reverse;
      padding-left: 0px;
      padding-right: 0px;
    }
  }


  //
  // Page 1
  //
  .page1 {
    width: calc(100% - 274px);

    // Responsive Style
    // @media max-width: 1024px
    @media(max-width: 1024px) {
      padding-left: 20px;
      padding-right: 20px;
    }

    // Responsive Style
    // @media max-width: 768px
    @media(max-width: 768px) {
      width: 100%;
    }
  }
</style>
